import type { ReactNode } from 'react';
import { Icon } from './Icon';

// The label line of a stat card: a small, muted, stat-appropriate icon next to
// the text. One shared primitive so every stat strip (bookings / dogs&owners /
// rota / account / daily) reads the same and the icon styling can't drift.
export function StatLabel({ icon, children }: { icon: string; children: ReactNode }) {
  return (
    <div className="label stat-label">
      <Icon name={icon} size={13} className="stat-ico" />
      <span>{children}</span>
    </div>
  );
}
